import { makeStyles, ThemeProvider } from "@material-ui/styles"
import grey from "@material-ui/core/colors/grey"

/**
 * @returns {any}
 */
const useStyles = makeStyles(theme => {
  const mediaScreenXs = `@media only screen and (max-width: ${theme.breakpoints.values.sm}px)`
  return {
    pageIntro: {
      paddingTop: theme.spacing(5), // now increased to 40px to match Figma design for BEC platform
      paddingBottom: theme.spacing(1),
      marginLeft: 0,
      marginRight: 0,
      marginBottom: theme.spacing(1),
    },
    selectInputMethod: {
      marginLeft: 0,
      marginRight: 0,
      marginBottom: theme.spacing(1),
      fontWeight: 900,
    },
    topSection: {},
    codePasteNote: {
      marginLeft: theme.spacing(1),
      marginTop: theme.spacing(1),
      color: grey[500],
    },
    inputCodeWrapper: {
      minHeight: 90,
      [mediaScreenXs]: {
        minHeight: 0,
      },
    },
    editorHeadSection: {
      marginTop: 0,
    },
    editorHeadStart: {
      fontWeight: "bold",
      marginBottom: theme.spacing(1),
    },
    editorHeadEnd: {},
    body: {
      width: "80%",
      margin: "auto",
    },
    navigateButtonWrapper: {
      width: "100%",
      textAlign: "center",
    },
    nextButton: {
      marginTop: theme.spacing(2.5),
      marginBottom: theme.spacing(2.5),
    },
    previousButton: {
      marginTop: theme.spacing(2.5),
    },
    editorSection: {
      paddingTop: theme.spacing(2.5),
      overflowX: "auto",
      height: 200,
      backgroundColor: theme.palette.common.white,
    },
    uploadSection: {
      paddingTop: theme.spacing(2),
      height: `${theme.spacing(2) + 50}px`, // note: it maybe possible to do without this line after EY-UI is updated
      [mediaScreenXs]: {
        height: "unset",
      },
    },
    buttonTextAfterIcon: {
      marginLeft: theme.spacing(1),
      marginBottom: -2,
    },
    criterionBox: {
      flex: 1,
    },
    criterionHead: {
      cursor: "pointer",
      borderBottom: "1px solid transparent",
      transition: "border-color 0.5s",
      "&:hover": {
        borderColor: theme.palette.primary.dark,
      },
    },
    outputDescription: {
      fontWeight: 300,
      color: grey[700],
      display: "flex",
      alignItems: "center",
      marginTop: theme.spacing(4),
     },
    outputDescriptionItem: {
      marginLeft: 0,
      marginRight: 0,
    },
    collapseAllWrapper: {
      display: "flex",
      justifyContent: "space-between",
    },
    outputSection: {
      marginTop: 20,
      paddingTop: 25,
      paddingBottom: theme.spacing(10),
      flexGrow: 1,
    },
    resultsHeading: {
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(1),
      textDecoration: "underline",
    },
    criteriaList: {
      display: "flex",
      paddingTop: theme.spacing(6),
      paddingBottom: theme.spacing(6),
    },
    criterionDescription: {
      paddingTop: theme.spacing(1),
      paddingRight: theme.spacing(1),
    },
    codeWrapper: {
      paddingLeft: theme.spacing(2),
      overflowX: "auto",
    },
    scanButton: {
      minWidth: 198,
      [mediaScreenXs]: {
        width: "100%",
        marginBottom: theme.spacing(2),
      },
    },
    scanButtonWrapper: {
      [mediaScreenXs]: {
        width: "100%",
        marginTop: theme.spacing(2),
      },
    },
    initiateScanSection: {
      display: "flex",
      justifyContent: "space-between",
      paddingTop: theme.spacing(1.5),
      [mediaScreenXs]: {
        flexDirection: "column-reverse",
      },
    },
    introEnd: {
      display: "inline-block",
    },
    versionSelect: {
      width: 300,
      [mediaScreenXs]: {
        width: "100%",
        marginBottom: theme.spacing(2),
      },
    },
    uploadButtonWrapper: {
      display: "inline-block",
      height: 50, // todo: remove when button fix is merged to here
    },
    uploadButton: {
      height: "100%",
    },
    fileSuccessWrapper: {
      display: "inline-flex",
      flexDirection: "column",
      marginLeft: theme.spacing(1),
      justifyContent: "space-between",
      height: "100%",
      verticalAlign: "top", // can we do without this somehow ???
      [mediaScreenXs]: {
        marginLeft: 0,
        marginTop: theme.spacing(1),
      },
    },
    uploadChipWrapper: {
      [mediaScreenXs]: {
        marginTop: theme.spacing(1),
      },
    },
    solidityVersionErr: {
      color: theme.palette.error.main,
      fontSize: "0.8rem",
      marginTop: 2,
    },
    compilationErrorList: {
      boxShadow: `0px 2px 1px -1px rgba(0,0,0,0.2),
    0px 1px 1px 0px rgba(0,0,0,0.14), 
    0px 1px 3px 0px rgba(0,0,0,0.12)`,
    },
    compilationErrorItem: {
      color: "#2E2E38",
      whiteSpace: "pre",
    },
    compilationErrorListItem: {
      overflow: "auto",
    },
    mobileCodeEditor: {
      width: "100%",
      height: "30vh",
      //prettier-ignore
      fontFamily: "\"Courier New\", Courier, monospace",
      fontSize: "1em",
      resize: "none",
      "&:focus": {
        outline: "none",
      },
    },
    swcChip: {
      marginRight: "5px",
    },
    selectContractAndScan: {
      display: "flex",
    },
    contractSelector: {
      marginRight: theme.spacing(2),
    },
    wrapper: {
      border: "1px solid #EAEAEE",
    },
    scanLoaderContainer: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      width: "300px",
      height: "200px",
      background: "white",
      justifyContent: "space-evenly",
    },
    scanLoaderContainerTitle: {
      fontSize: "1.25rem",
    },
    interactiveBtn: {
      cursor: "pointer",
      border: "1px solid black",
      display: "inline-block",
      padding: "10px 20px",
      fontWeight: 600,
      background: "white",
    },
    loaderContainer: {
      position: "fixed",
      left: 0,
      top: 0,
      width: "100%",
      height: "100%",
      background: "rgba(0, 0, 0, 0.45)",
      zIndex: 5000,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    codeEditorHeight:{
      maxHeight: '600px'
    }
  }
})

export default useStyles
